import { useState } from 'react';
import { Conditional, IconMinusCircle, IconPlusCircle, Text } from '@consumidor-positivo/aurora';

import './styles.scss';
import classNames from 'classnames';
type SearchConfigProps = {
  children: React.ReactNode;
};

export const SearchConfig = ({ children }: SearchConfigProps) => {
  const [openSearch, setOpenSearch] = useState(false);
  const bodyClass = classNames('mm-search-config__body', {
    'mm-search-config__body--open': openSearch,
  });

  const titleClass = classNames('mm-search-config__title', {
    'mm-search-config__title--open': openSearch,
  });

  return (
    <div className="mm-search-config">
      <div className={titleClass}>
        <Text as="span" variant="body-small" weight="semibold" color="secondary">
          Configuração de pesquisa
        </Text>
        <button onClick={() => setOpenSearch(!openSearch)}>
          <Conditional condition={openSearch} renderIf={<IconMinusCircle />} renderElse={<IconPlusCircle />} />
        </button>
      </div>
      <div className={bodyClass}>
        <div className="mm-search-config__content">{children}</div>
      </div>
    </div>
  );
};
